<template functional>
  <div id="header" key="theHeader" class="headerCommon">
    <div class="redZone pc">
      <div class="width960">
        <p>
          <a href="/">
            <img
              src="//www.tabikobo.com/images/common/logo_white.svg"
              alt="TABIKOBO"
              height="25px"
            />
          </a>
        </p>
        <ul>
          <li>
            <a href="/tellist/">
              <img
                src="//www.tabikobo.com/images/common/tel_white.svg"
                height="20px"
                width="20px"
                alt="電話で予約"
              />
              電話で予約
            </a>
          </li>
          <li>
            <a href="https://faq.tabikobo.com/?site_domain=default">
              <img
                src="//www.tabikobo.com/images/common/hatena_white.svg"
                height="20px"
                width="12px"
                alt="よくある質問"
              />
              よくある質問
            </a>
          </li>
          <li>
            <a :href="$options.historyLink(props)">
              <img
                src="//www.tabikobo.com/images/common/clock_white.svg"
                height="20px"
                width="20px"
                alt="閲覧履歴"
              />
              閲覧履歴
            </a>
          </li>
          <li>
            <a :href="$options.favoriteLink(props)">
              <img
                src="//www.tabikobo.com/images/common/heart_white.svg"
                height="20px"
                width="26px"
                alt="お気に入り"
              />
              お気に入り
            </a>
          </li>
          <li class="mypage">
            <a href="//my.tabikobo.com/">
              <img
                src="//www.tabikobo.com/images/common/account.png"
                height="25px;"
                width="25px"
                alt="マイページ"
              />
              マイページ
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="whiteZone pc">
      <div class="width960">
        <div style="width: 16.7%; display: flex; justify-content: center;">
          <p class="globalMenu">
            <a href="/">
              <img
                width="40px"
                height=""
                src="//www.tabikobo.com/images/common/icon_overseas.svg"
                alt="海外旅行"
              />
              <span>海外旅行</span>
            </a>
          </p>
        </div>
        <div style="width: 16.7%; display: flex; justify-content: center;">
          <p class="globalMenu">
            <a href="/outlet/">
              <img width="40px" height="" src="//www.tabikobo.com/images/common/icon_lineup.png" alt="LINE UP" />
              <span>厳選ツアー</span>
            </a>
          </p>
        </div>
        <div style="width: 16.7%; display: flex; justify-content: center;">
          <p class="globalMenu">
            <a href="/special/hitori/">
              <img width="40px" height="" src="//www.tabikobo.com/images/common/icon_alone.png" alt="一人旅">
              <span>一人旅</span>
            </a>
          </p>
        </div>
        <div style="width: 16.7%; display: flex; justify-content: center;">
          <p class="globalMenu">
            <a href="/special/">
              <img width="40px" height="" src="//www.tabikobo.com/images/common/icon_special.svg" alt="特集">
              <span>特集</span>
            </a>
          </p>
        </div>
        <div style="width: 16.7%; display: flex; justify-content: center;">
          <p class="globalMenu">
            <a href="/parts/">
              <img
                width="40px"
                height=""
                src="//www.tabikobo.com/images/common/icon_parts.svg"
                alt="旅行サービス"
              />
              <span>旅行サービス</span>
            </a>
          </p>
        </div>
        <div style="width: 16.7%; display: flex; justify-content: center;">
          <p class="globalMenu">
            <a href="/corporate/">
              <img
                width="40px"
                height=""
                src="//www.tabikobo.com/images/common/icon_corporate.svg"
                alt="法人・団体"
              />
              <span>法人・団体</span>
            </a>
          </p>
        </div>
      </div>
    </div>

    <div class="spNavi sp">
      <div class="left">
        <p class="logo">
          <a href="/">
            <img
              src="//www.tabikobo.com/images/common/logo_sp.svg"
              alt="TABIKOBO"
            />
          </a>
        </p>
      </div>
      <div
        class="right"
        :class="{ '-wide': props.additionalDisplay || props.tour }"
      >
        <div class="head_search">
          <a :href="$options.tourLink(props)">
            <img
              src="//www.tabikobo.com/images/common/search_red.svg"
              alt="ツアー検索"
            />
            <p class="search_cap">ツアー検索</p>
          </a>
        </div>
        <div
          class="head_history"
          :class="{ '-display': props.additionalDisplay }"
        >
          <a :href="$options.historyLink(props)">
            <img
              src="//www.tabikobo.com/images/common/clock.svg"
              alt="閲覧履歴"
            />
            <p class="history_cap">閲覧履歴</p>
          </a>
        </div>
        <div
          class="head_fav"
          :class="{ '-display': props.additionalDisplay || props.tour }"
        >
          <a :href="$options.favoriteLink(props)">
            <img
              src="//www.tabikobo.com/images/common/heart.svg"
              alt="お気に入り"
            />
            <p class="fav_cap">お気に入り</p>
          </a>
        </div>
        <div
          class="head_tel"
          :class="{ '-display': props.tour }"
        >
          <a href="/tellist/">
            <img
              class="tel_img"
              src="https://www.tabikobo.com/images/common/btn_sp_tel.png"
              alt="電話"
            />
            <p class="tel_cap">電話</p>
          </a>
        </div>
        <div class="menu">
          <p class="menu_cap">メニュー</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheHeader',
  props: {
    japanGiving: {
      type: Boolean,
      default: false,
    },
    additionalDisplay: {
      type: Boolean,
      default: false,
    },
    tour: {
      type: Boolean,
      default: false,
    },
  },
  // TODO お気に入り・履歴が全て置き換わった後にこの処理は削除すること
  historyLink(props) {
    return props.japanGiving ? '/japan/tour/history/' : '/tour/history/'
  },
  favoriteLink(props) {
    return props.japanGiving ? '/japan/tour/favorite/' : '/tour/favorite/'
  },
  tourLink(props) {
    if (props.tour) {
      const qs = new URLSearchParams(window.location.search)
      const domestic = qs.has('domestic') ? `domestic=${encodeURIComponent(qs.get('domestic'))}&` : ''
      return `/tour/tourresult?${domestic}show_research=1`
    } else {
      return '/japan/tour-free'
    }
  },
}
</script>

<style lang="scss">
@media (max-width: 657px) {
  .headerCommon .spNavi.sp .right.-wide {
    width: 220px;
  }

  .headerCommon .spNavi.sp .right .head_history {
    display: none;

    &.-display {
      display: inline-block;
    }
  }

  .headerCommon .spNavi.sp .right .head_fav.-display {
    display: inline-block;
  }

  .headerCommon .spNavi.sp .right .head_tel {
    display: none;

    &.-display {
      display: inline-block;
      width: 60px;
      background: none;
      border: none;
      height: 40px;
      margin: 0;
      float: none;
      position: relative;
      vertical-align: top;
      text-align: center;
    }
  }

  .headerCommon .spNavi.sp .right .head_tel .tel_img {
    margin-top: 0;
    width: auto;
    height: 22px;
  }

  .headerCommon .spNavi.sp .right .head_tel .tel_cap {
    font-size: 10px;
    color: #333;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    line-height: 1;
    vertical-align: bottom;
  }
}
</style>
